import camelCase from '../lib/camelCase'
import Immutable from 'immutable'

function transformServicesFromApi(payload) {
    return camelCase(payload);
}

export function get(api, params = {}) {
    return api.get(api.url(`services/${params.service}/${params.region}/products`), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformServicesFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};
